<template>
    <v-dialog
        transition="dialog-bottom-transition"
        max-width="1200px"
        v-model="dialog"
    >
        <template v-slot:activator="{ props: activatorProps }">
            <v-list-item v-bind="activatorProps" style="background-color: #C4CBFF">
                <v-list-item-title style="color: #3848C7">
                    Informar a IOMA
                    <v-icon>mdi mdi-arrow-right</v-icon>
                </v-list-item-title>
            </v-list-item>
        </template>

        <template v-slot:default="{ isActive }">
            <v-card>
                <v-toolbar title="Cargar Informe a IOMA" style="text-align: center;" class="modal-header"></v-toolbar>
                    <v-data-table 
                        :headers="headers"
                        :items="practicasLocales"
                        hide-default-footer
                        height="300"
                        item-value="name"
                        no-data-text="No hay practicas"
                        disable-sort
                    >
                    <template v-slot:[`item.files`]="{ item }">
                        <v-row class="align-center justify-center" dense>
                            <!-- Mostrar los archivos existentes -->
                            <template v-if="item.files && item.files.length > 0">
                                <v-col cols="12">
                                    <v-row v-for="archivo in item.files" :key="archivo.guid || archivo.id" class="mb-2 justify-start">
                                        <!-- Nombre del archivo -->
                                        <v-col cols="12" md="4" class="d-flex align-center justify-start">
                                            <v-icon class="mr-2" size="large">mdi-file-document</v-icon>
                                            <span>{{ archivo.nombre }}</span>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </template>
                        </v-row>
                    </template>
                    <template v-slot:[`item.filesAccion`]="{ item }">
                        <v-row class="align-start justify-start" dense>
                            <!-- Botón para agregar archivos - se muestra si NO hay archivos -->
                            <v-col cols="12" v-if="(!item.files || item.files.length === 0 || !item.files.some(f => f.tipoDocumentacion === 1)) && item.estado !== 'Facturable'" class="d-flex justify-start">
                                <v-tooltip text="Añadir informe" location="top">
                                    <template v-slot:activator="{ props: tooltipProps }">
                                        <v-btn
                                            v-bind="tooltipProps"
                                            icon="mdi mdi-plus"
                                            size="large"
                                            color="red"
                                            @click="abrirDialogArchivos(item)"
                                        ></v-btn>
                                    </template>
                                </v-tooltip>
                            </v-col>
                            
                            <!-- Mostrar los archivos existentes -->
                            <template v-if="item.files && item.files.length > 0">
                                <v-col cols="12">
                                    <div v-for="archivo in item.files" :key="archivo.guid" class="d-flex align-center gap-2 mb-2">
                                        <v-tooltip text="Ver documento" location="top">
                                            <template v-slot:activator="{ props }">
                                                <v-btn
                                                    v-bind="props"
                                                    @click="openFileInNewTab({ tipoMime: archivo.tipoMime, nombre: archivo.nombre, guid: archivo.guid })"
                                                    icon="mdi mdi-eye"
                                                    size="small"
                                                ></v-btn>
                                            </template>
                                        </v-tooltip>
                                        
                                        <v-tooltip text="Descargar documento" location="top">
                                            <template v-slot:activator="{ props }">
                                                <v-btn
                                                    v-bind="props"
                                                    @click="downloadFile({ tipoMime: archivo.tipoMime, nombre: archivo.nombre, guid: archivo.guid })"
                                                    icon="mdi mdi-download"
                                                    size="small"
                                                ></v-btn>
                                            </template>
                                        </v-tooltip>
                                        
                                        <v-tooltip text="Eliminar documento" location="top">
                                            <template v-slot:activator="{ props }">
                                                <v-btn
                                                    v-bind="props"
                                                    @click="eliminarArchivo({ guid: archivo.guid, idSolicitudPractica: item.id })"
                                                    icon="mdi mdi-trash-can"
                                                    size="small"
                                                ></v-btn>
                                            </template>
                                        </v-tooltip>
                                    </div>
                                </v-col>
                            </template>
                        </v-row>
                    </template>
                </v-data-table>
                <v-card-actions class="justify-end" style="padding-bottom: 16px;">
                    <v-btn
                        text="Cerrar"
                        id="boton-verde"
                        @click="{isActive.value = false; cerrarModal()}"
                        :disabled="cargando"
                    ></v-btn>
                    <v-btn
                        text="Informar"
                        id="boton-verde"
                        :disabled="!puedoInformar"
                        :loading="cargando"
                        @click="informarSolicitud()"
                    ></v-btn>                    
                </v-card-actions>
            </v-card>
        </template>
    </v-dialog>

    <!-- DIALOG DE ARCHIVOS FUERA DEL DIALOG PRINCIPAL -->
    <v-dialog v-model="dialogAgregarArchivos" max-width="700px">
        <v-card>
            <v-toolbar title="Agregar documentación" style="text-align: center;" class="modal-header">
                <v-btn 
                    icon="mdi-close" 
                    @click="cerrarDialogArchivos()"
                ></v-btn>
            </v-toolbar>
            
            <v-card-text class="pa-4">
                <AgregarArchivosConTipo
                    @close="cerrarDialogArchivos()"
                    @agregarArchivos="agregarArchivos"
                    :tiposDocumentacion="[{ nombre: 'Informe', valor: tiposDocumentacion }]"
                    :archivosActuales="practicaSeleccionada.files || []"
                    :maxImagesPorTipo="1"
                />
            </v-card-text>
        </v-card>
    </v-dialog>

    <AlertComponent
        :title="alertTitle"
        :text="alertText"
        :alertType="alertType"
        :showAlert="showAlert"
        @close="showAlert = false"
    ></AlertComponent>
    <ConfirmacionDialog
        :dialogConfirm="dialogConfirm"
        :mensajeConfirm="mensajeConfirm"
        @confirmar="confirmar"
        @cancelar="cancelar"
    />
</template>

<style src="../assets/general.css"></style>

<script>
import PrestacionService from '@/api/PrestacionService';
import GeneralService from '@/api/GeneralService';
import AlertComponent from './AlertComponent.vue';
import ConfirmacionDialog from './ConfirmacionDialog.vue';
import AgregarArchivosConTipo from './AgregarArchivosConTipo.vue';

const generalService = new GeneralService();
const prestacionService = new PrestacionService();

export default {
    components: {
        AlertComponent,
        ConfirmacionDialog,
        AgregarArchivosConTipo,
    },
    data: () => ({
        dialog: false,
        dialogAgregarArchivos: false,
        practicaSeleccionada: null,
        practicasLocales: [],
        headers: [
            { title: "Descripción Práctica", key:"prestaciondescripcion" },
            { title: "Diagnóstico", key:"prestacionDiagnostico" },
            { title: "Código Práctica", key:"prestacioncodigo" },
            { title: "Archivos", key:"files" },
            { title: "Acciones", key:"filesAccion" }
        ],  
        puedoInformar: false,
        files: [],
        blobUrl: null,
        archivoAEliminar: {
            idSolicitud: "",
            idSolicitudPractica: "",
            idArchivo: "",
        },
        alertTitle: '',
        alertText: '',
        alertType: '',
        showAlert: false,
        cargando: false,
        dialogConfirm: false,
        mensajeConfirm: '',
        resolverConfirm: null,
        mostrarEliminar: true,
        tiposDocumentacion: 1,
        archivosActuales: [],
        prestacionConArchivos: {
            idSolicitud: "",
            idSolicitudPractica: "",
            archivos: []
        },
    }),
    props: {
        idSolicitud: {
            type: Number,
            required: true,
        },
        practicas: {
            type: Array,
            default: () => []
        },
        solicitud: {
            type: Object,
            required: true,
        },
        files2: {
            type: Array,
            required: true
        },
    },
    async mounted(){
        // Crear copia de las prácticas
        this.practicasLocales = JSON.parse(JSON.stringify(this.practicas));
        this.practicasLocales = this.practicasLocales.filter(d => d.estado === 'EsperandoInforme' || d.estado === 'InformePresentado');


        if(this.practicasLocales.length > 0){
            this.practicasLocales.forEach(d => {
                if(d.files && d.files.length > 0) {
                    d.files.forEach(f => {
                        this.files.push({
                            dominio: d.prestacioncodigo,
                            nombre: f.nombre,
                            fechaCreacion: f.fechaCreacion ? 
                                f.fechaCreacion.split('T')[0] + ' ' + f.fechaCreacion.split('T')[1].split('.')[0]
                                : 'No indicada',
                            tipoMime: f.tipoMime,
                            contenidoBase64: '',
                            idSolicitudPractica: d.id,
                            guid: f.guid,
                            tipoDocumentacion: f.tipoDocumentacion
                        })
                    });
                } else {
                    this.mostrarEliminar = false;
                }
            });
        }
        await this.verificarPuedeInformar();
        this.prestacionConArchivos.idSolicitud = this.idSolicitud;
        console.log(this.practicasLocales);
    },
    methods: {
        cerrarModal(){
            this.$emit('actualizar');
        },
        abrirDialogArchivos(practica) {
            this.practicaSeleccionada = practica;
            this.dialogAgregarArchivos = true;
        },

        cerrarDialogArchivos() {
            this.dialogAgregarArchivos = false;
        },
        
        async agregarArchivos(archivos) {
            let practica = this.practicaSeleccionada;
            if (!practica) {
                this.alertTitle = 'Error';
                this.alertText = 'No se pudo identificar la práctica seleccionada';
                this.alertType = 'error';
                this.showAlert = true;
                return;
            }

            // Prevenir múltiples clics
            if (this.cargando) return;
            
            this.cargando = true;
            
            try {
                this.prestacionConArchivos.idSolicitudPractica = practica.id;
                this.prestacionConArchivos.archivos = archivos;

                const response = await prestacionService.agregarArchivosASolicitud(this.prestacionConArchivos);
                
                if (response && response.status === 200) {
                    const archivosNuevos = response.data.archivosAgregados.map(a => ({
                        nombre: a.nombre,
                        fechaCreacion: a.fechaCreacion || new Date().toISOString(),
                        tipoMime: a.tipoMime,
                        contenidoBase64: '',
                        idSolicitudPractica: practica.id,
                        guid: a.id,
                        tipoDocumentacion: a.tipoDocumentacion
                    }));

                    const practicaIndex = this.practicasLocales.findIndex(p => p.id === practica.id);
                    if (practicaIndex !== -1) {
                        if (!this.practicasLocales[practicaIndex].files) {
                            this.practicasLocales[practicaIndex].files = [];
                        }
                        this.practicasLocales[practicaIndex].files.push(...archivosNuevos);
                    }
                    
                    await this.verificarPuedeInformar();
                    
                    this.alertTitle = 'Archivo agregado';
                    this.alertText = 'El archivo se ha agregado correctamente a la práctica';
                    this.alertType = 'success';
                    this.showAlert = true;
                    
                    // Cerrar el diálogo después de un agregado exitoso
                    this.cerrarDialogArchivos();
                } else {
                    this.alertTitle = 'Error';
                    this.alertText = response?.data || 'Error al agregar los archivos';
                    this.alertType = 'error';
                    this.showAlert = true;
                }
            } catch (error) {
                console.error('Error al agregar archivos:', error);
                this.alertTitle = 'Error';
                this.alertText = 'Ha ocurrido un error al agregar los archivos';
                this.alertType = 'error';
                this.showAlert = true;
            } finally {
                this.cargando = false;
            }
        },
        
        async verificarPuedeInformar() {
            let cantidadInformes = 0;
            this.practicasLocales.filter(p => p.estado !== 'Facturable').forEach(practica => {
                if (practica.files && practica.files.length > 0) {
                    cantidadInformes += practica.files.filter(f => f.tipoDocumentacion == 1).length;
                }
            });
            const cantidadPracticas = this.practicasLocales.filter(p => p.estado !== 'Facturable').length;
            this.puedoInformar = (cantidadInformes == cantidadPracticas);
        },

        async informarSolicitud() {
            const confirmacion = await this.mostrarConfirmacion(
                '¿Está seguro que desea enviar esta solicitud a informar? Esta acción es IRREVERSIBLE. Verifique que todos los informes estén cargados correctamente por favor.'
            );

            if (!confirmacion) return;

            this.cargando = true;
            try {
                const response = await prestacionService.informarSolicitudIOMA(this.idSolicitud);
                if (response.success || response.status === 200) {
                    this.alertTitle = 'Solicitud informada';
                    this.alertText = 'La solicitud se ha enviado a informar correctamente';
                    this.alertType = 'success';
                    this.showAlert = true;
                } else {
                    this.alertTitle = 'Error';
                    this.alertText = response?.data || 'Error al informar';
                    this.alertType = 'error';
                    this.showAlert = true;
                }
            } catch (error) {
                this.alertTitle = 'Error';
                this.alertText = 'Ha ocurrido un error al informar la solicitud';
                this.alertType = 'error';
                this.showAlert = true;
            } finally {
                this.cargando = false;
            }
        },

        async recuperarArchivo(mimeType, fileName, guid) {
            const response = await generalService.getArchivo(guid);
            if(response && response.status === 200){
                const mimeType = response.data.tipoMime;
                const base64Content = response.data.contenidoBase64;
                const byteCharacters = atob(base64Content);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], { type: mimeType });
                this.blobUrl = URL.createObjectURL(blob);
            } else {
                this.alertTitle = 'Error';
                this.alertText = 'Ha ocurrido un error al recuperar el archivo';
                this.alertType = 'error';
                this.showAlert = true;
            }
        },
        
        async downloadFile({ tipoMime, nombre, guid }) {
            await this.recuperarArchivo(tipoMime, nombre, guid);
            const a = document.createElement('a');
            a.href = this.blobUrl;
            a.download = nombre;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(this.blobUrl);
        },
        
        mostrarConfirmacion(mensaje) {
            this.mensajeConfirm = mensaje;
            this.dialogConfirm = true;
            return new Promise((resolve) => {
                this.resolverConfirm = resolve;
            });
        },
        
        confirmar() {
            this.dialogConfirm = false;
            if (this.resolverConfirm) this.resolverConfirm(true);
            this.resolverConfirm = null;
        },
        
        cancelar() {
            this.dialogConfirm = false;
            if (this.resolverConfirm) this.resolverConfirm(false);
            this.resolverConfirm = null;
        },
        
        async eliminarArchivo({ guid, idSolicitudPractica }) {
            const mensaje = "¿Estás seguro que querés eliminar este archivo?";
            console.log('id-File: ' + guid);
            console.log('id-Solicitud: ' + idSolicitudPractica);

            const confirmacion = await this.mostrarConfirmacion(mensaje);
            if (!confirmacion) return;
            
            this.cargando = true;
            this.archivoAEliminar.idArchivo = guid;
            this.archivoAEliminar.idSolicitud = this.idSolicitud;
            this.archivoAEliminar.idSolicitudPractica = idSolicitudPractica;
            
            const response = await prestacionService.eliminarArchivoDeSolicitud(this.archivoAEliminar);
            
            this.cargando = false;
            
            if (response && response.status === 200) {
                // Eliminar el archivo del array local
                const practicaIndex = this.practicasLocales.findIndex(p => p.id === idSolicitudPractica);
                if (practicaIndex !== -1 && this.practicasLocales[practicaIndex].files) {
                    this.practicasLocales[practicaIndex].files = this.practicasLocales[practicaIndex].files.filter(
                        f => (f.guid || f.id) !== guid
                    );
                }
                
                // Verificar si todavía se puede informar
                await this.verificarPuedeInformar();
                
                this.alertTitle = 'Archivo eliminado';
                this.alertText = 'El archivo se ha eliminado correctamente';
                this.alertType = 'success';
                this.showAlert = true;
            } else {
                this.alertTitle = 'Error';
                this.alertText = response?.data || 'Error al eliminar el archivo';
                this.alertType = 'error';
                this.showAlert = true;
            }
        },
        
        async openFileInNewTab({ tipoMime, nombre, guid }) {
            await this.recuperarArchivo(tipoMime, nombre, guid);
            const newTab = window.open(this.blobUrl, '_blank');
            if (!newTab) {
                alert('Por favor, permite las ventanas emergentes para este sitio.');
            }
        },        
    }
}
</script>